let prefix = '/api/evidences';
import _ from "lodash";

function update(idEvidence, data){
    return window.axios.post(prefix+'/'+idEvidence+'/update',data);
}

function StoreEvidencesObjets(entity_id , entity_type , evidence_type, files) {
    let formData = new FormData()    
    formData.append('entity_type', entity_type);
    formData.append('entity_id', entity_id);
    formData.append('evidence_type', evidence_type);
    
    _.forEach(files, file => {
        formData.append('document[]', file);
        
    })
    return window.axios.post(prefix + '/storeEvidence',formData);
}

function download(resource){
    return window.axios.post(prefix+ '/download', {
        resource: resource,
    }, { responseType: 'blob' });
}

export default {
    update, StoreEvidencesObjets,download
}